<template>
  <van-overlay :show="visible">
    <div class="van-dialog">
      <div class="van-dialog__header">手写签名</div>
      <div class="van-dialog__content">
        <div>
          <canvas
              ref="canvas"
              class="mycanvas"
              canvas-id="mycanvas"
              disable-scroll="true"
              @touchstart="touchStart"
              @touchmove="touchMove"
              @touchend="touchEnd">
          </canvas>
        </div>
      </div>
      <div class=" van-dialog__footer" style="display: flex;justify-content: space-around;padding: 15px">
        <van-button @click="clear">
          <span>清空</span>
        </van-button>
        <van-button  @click="confirm">
          <span>签署协议</span>
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import {Toast} from "vant";
import {uploadFile} from "@/api/cos";
import {handlePromise} from "@/libs/util";

export default {
  name: "HandwriteDialog",
  data() {
    return {
      visible: false,
      signUrl: null,
      ctx: '', //绘图图像
      points: [], //路径点集合,
      canvas: {
        width: 0,
        height: 0
      },
    }
  },
  methods: {
    clear(){
      const {width,height} = this.$refs.canvas.getBoundingClientRect()
      this.$refs.canvas.getContext('2d').clearRect(0, 0, width, height);
    },
    canvasReadTouch(canvas, e) {
      let canvasRect = canvas.getBoundingClientRect();
      let touch = e.touches[0];
      canvas.tc_x1 = canvas.tc_x2;
      canvas.tc_y1 = canvas.tc_y2;
      canvas.tc_x2 = touch.pageX - document.documentElement.scrollLeft - canvasRect.left;
      canvas.tc_y2 = touch.pageY - document.documentElement.scrollTop - canvasRect.top;
    },
    touchStart(e) {
      this.canvasReadTouch(this.$refs.canvas, e);
      this.$refs.canvas.tc_md = true;
    },
    touchEnd(e) {
      this.$refs.canvas.tc_md = false;
    },
    touchMove(e) {
      const canvas = this.$refs.canvas
      this.canvasReadTouch(canvas, e);
      if (canvas.tc_md && (canvas.tc_x1 !== canvas.tc_x2 || canvas.tc_y1 !== canvas.tc_y2)) {
        //alert(`${canvas.tc_x1} ${canvas.tc_y1} ${canvas.tc_x2} ${canvas.tc_y2}`);
        let ctx = canvas.getContext("2d");
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo(canvas.tc_x1, canvas.tc_y1);
        ctx.lineTo(canvas.tc_x2, canvas.tc_y2);
        ctx.stroke();
      }
    },
    show() {
      this.visible = true
    },
    confirm() {
      Toast.loading({
        mask: true,
        message: '加载中'
      })
      fetch(this.$refs.canvas.toDataURL('image/png', 1))
          .then(res => res.blob())
          .then((blob)=>{
            const file = new File([blob], 'sign.png');
            uploadFile(this.$store.state.shop.id,'sign',file).then((url)=>{
              Toast.clear()
              this.visible = false
              this.$emit('success', url)
            })
          })

      // this.visible = false
      // this.$emit('success', this.signUrl)
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.mycanvas{
  width: 100%;
  background: #e5e5e5;
}
</style>
